import React from "react";
import { Helmet } from "react-helmet-async";

export default function SchemaMarkup({ type, service, location, client, data }) {
  // If raw data object passed (blog, generic pages), use it directly
  if (data) {
    return (
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": type || "WebPage",
          ...data,
        })}</script>
      </Helmet>
    );
  }

  // Guard against missing props
  if (!client || !service || !location) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": type || "MedicalBusiness",
    "name": `${client.name} - ${service.display} in ${location.city}`,
    "description": `Expert ${service.display.toLowerCase()} in ${location.city}, ${location.state}. Free consultation.`,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": location.address,
      "addressLocality": location.city,
      "addressRegion": location.state,
      "addressCountry": "US"
    },
    "geo": { "@type": "GeoCoordinates", "latitude": location.lat, "longitude": location.lng },
    "telephone": client.phone,
    "url": `https://${client.domain}/${location.slug}/${service.slug}`,
    "areaServed": { "@type": "City", "name": location.city },
    "medicalSpecialty": service.category
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
